export function findNearestCandle(data: any[], timestamp: number): number | null {
  let left = 0;
  let right = data.length - 1;

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);
    const midTimestamp = data[mid].time;

    if (midTimestamp === timestamp) {
      return mid;
    } else if (midTimestamp < timestamp) {
      left = mid + 1;
    } else {
      right = mid - 1;
    }
  }

  // At this point, 'right' and 'left' have crossed each other
  // 'right' will be the index of the nearest data point to the left of the timestamp
  // 'left' will be the index of the nearest data point to the right of the timestamp
  const indexToLeft = right;
  const indexToRight = left;

  // Find the nearest index by comparing the distance to the left and right data points
  if (indexToLeft >= 0 && indexToRight < data.length) {
    const leftTimestamp = data[indexToLeft].time;
    const rightTimestamp = data[indexToRight].time;

    const distanceToLeft = Math.abs(timestamp - leftTimestamp);
    const distanceToRight = Math.abs(timestamp - rightTimestamp);

    return distanceToLeft < distanceToRight ? indexToLeft : indexToRight;
  } else if (indexToLeft >= 0) {
    return indexToLeft;
  } else if (indexToRight < data.length) {
    return indexToRight;
  } else {
    return null;
  }
}
